import axios from "axios";

const instance = axios.create();

instance.defaults.headers.post["Content-Type"] = "application/json";
instance.defaults.withCredentials = true;

export const registerExpirationListener = (func: () => void): number => {
  return instance.interceptors.response.use(
    config => config,
    err => {
      if (err.status === 401) {
        func();
        return;
      }

      throw err;
    }
  );
};

export const unregisterExpirationListener = (num: number) => {
  instance.interceptors.request.eject(num);
};

export const init = (baseUrl: string) => {
  instance.defaults.baseURL = baseUrl;
};

export default instance;
